module.exports = __webpack_public_path__ + "static/media/ai.007b5b95.svg";